import { Stack } from '@genial/components';
import { BoxBorder } from '@genial/design-tokens';
import React from 'react';

interface CustomerDuckMobileValueContainerProps {
  children: React.ReactNode;
}

export const CustomerDuckMobileValueContainer: React.FC<CustomerDuckMobileValueContainerProps> = ({
  children,
}) => {
  return (
    <Stack flex={1} px="inline.xxxs" py="stack.nano" bg="background" borderRadius={BoxBorder.thick}>
      {children}
    </Stack>
  );
};
